import gql from 'graphql-tag';

export const permissions = gql`
  query loadAllPermissionCategories {
    loadAllPermissionCategories {
      status
      code
      data {
        id
        name
        active
      }
    }
  }
`;

export const area = gql`
  query searchAdministrativeAreaByName($input: String) {
    searchAdministrativeAreaByName(administrativeName: $input) {
      code
      status
      data {
        id
        name
        label
      }
    }
  }
`;
export const residence = gql`
  query searchResidenceAreaByName($input: String) {
    searchResidenceAreaByName(administrativeName: $input) {
      code
      status
      data {
        id
        active
        name
        council {
          id
          name
          region {
            id
            name
          }
        }
      }
    }
  }
`;

export const updateFacilityLocation = gql`
  mutation updateFacilityLocation($facilityId: Long, $locationId: Int) {
    updateFacilityLocation(facilityId: $facilityId, locationId: $locationId) {
      code
      status
      data {
        residence {
          id
          name
        }
      }
    }
  }
`;

export const saveTile = gql`
  mutation saveTile($tileDto: TileDtoInput) {
    saveTile(tileDto: $tileDto) {
      code
      status
      data {
        id
        title
        colour
        icon
        link
      }
    }
  }
`;

export const roles = gql`
  query getAllRoles {
    getAllRoles {
      code
      status
      data {
        id
        name
        displayName
        description
        facilityCode
        permissionList {
          id
          name
          roles {
            tilesList {
              id
              colour
              icon
              title
              link
            }
          }
        }
      }
    }
  }
`;

export const loadPermissionsByCategoryName = gql`
  query loadPermissionsByCategoryName($permissionCategoryName: String) {
    loadPermissionsByCategoryName(
      permissionCategoryName: $permissionCategoryName
    ) {
      status
      code
      data {
        id
        name
        displayName
        description
        serviceName
        permissionCategory {
          id
          name
        }
      }
    }
  }
`;

export const updateRole = gql`
  mutation updateRole($RoleDto: RoleDtoInput) {
    updateRole(RoleDto: $RoleDto) {
      status
      code
      data {
        id
        name
        displayName
        description
        permissionList {
          id
          name
          displayName
          description
          serviceName
        }
        tilesList {
          id
          title
          colour
          icon
          link
        }
      }
    }
  }
`;
export const saveRole = gql`
  mutation saveRole($RoleDto: RoleDtoInput) {
    saveRole(RoleDto: $RoleDto) {
      code
      status
      data {
        id
        name
        displayName
        description
        permissionList {
          id
          name
        }
        tilesList {
          id
          title
          colour
          icon
          link
        }
      }
    }
  }
`;

export const getAllTiles = gql`
  query getAllTiles {
    getAllTiles {
      code
      status
      data {
        id
        title
        colour
        icon
        link
      }
    }
  }
`;

export const loadAllPermissions = gql`
  query loadAllPermissions {
    loadAllPermissions {
      code
      status
      data {
        id
        name
        displayName
        serviceName
        description
        permissionCategory {
          id
          name
        }
      }
    }
  }
`;

export const departments = gql`
  query loadDepartmentsByFacility($facilityCode: String) {
    loadDepartmentsByFacility(facilityCode: $facilityCode) {
      code
      status
      data {
        id
        name
        medical
      }
    }
  }
`;

export const assignPermissions = gql`
  mutation assignAllPermissionsToRole($RoleDto: RoleDtoInput) {
    assignAllPermissionsToRole(RoleDto: $RoleDto) {
      status
      code
      data {
        id
        name
        displayName
        description
        permissionList {
          id
          name
        }
        tilesList {
          id
          title
          colour
          icon
          link
        }
      }
    }
  }
`;

export const saveUser = gql`
  mutation saveUser($userAccountDto: UserAccountDtoInput) {
    saveUser(userAccountDto: $userAccountDto) {
      status
      code
      data {
        accountNonExpired
        accountNonLocked
        active
        otp
        residence
        authorities {
          authority
        }
        roles {
          id
          name
          displayName
          description
          permissionList {
            id
            name
            description
            displayName
          }
          tilesList {
            id
            title
            colour
            icon
            link
          }
        }
        checkNumber
        createdAt
        createdBy
        credentialsNonExpired
        deletedAt
        deletedBy
        departmentList {
          id
          name
          departmentCode
          medical
        }
        email
        enabled
        firstLogin
        id
        medicalStaff
        mobileNumber
        name
        nextAttemptAt
        numberOfAttempt
        username
      }
    }
  }
`;

export const updateUser = gql`
  mutation updateUserAccount($userAccountDto: UserAccountUpdateDtoInput) {
    updateUserAccount(userAccountDto: $userAccountDto) {
      code
      status
      data {
        accountNonExpired
        accountNonLocked
        active
        otp
        residence
        authorities {
          authority
        }
        roles {
          id
          name
          displayName
          description
          permissionList {
            id
            name
            description
            displayName
          }
          tilesList {
            id
            title
            colour
            icon
            link
          }
        }
        checkNumber
        createdAt
        createdBy
        credentialsNonExpired
        deletedAt
        deletedBy
        departmentList {
          id
          name
          departmentCode
          medical
        }
        email
        enabled
        firstLogin
        id
        medicalStaff
        mobileNumber
        name
        nextAttemptAt
        numberOfAttempt
        username
      }
    }
  }
`;

export const searchByFacilityNameOrCode = gql`
  query searchByFacilityNameOrCode($searchParam: String) {
    searchByFacilityNameOrCode(searchParam: $searchParam) {
      status
      code
      data {
        id
        facilityCode
        email

        residence {
          id
          name
        }
        city
        name
        facilityType {
          id
          name
        }
      }
    }
  }
`;
export const findAllRoles = gql`
  query findAllRoles {
    findAllRoles {
      status
      code
      data {
        id
        name
        displayName
        description
        permissionList {
          id
          name
          displayName
          description
          serviceName
        }
        tilesList {
          id
          title
          colour
          icon
          link
        }
      }
    }
  }
`;

export const facilities = gql`
  query getAllFacilities {
    getAllFacilities {
      code
      status
      data {
        id
        name
        residence {
          id
          name
          council {
            id
            name
            region {
              id
              name
            }
          }
        }
        email
        facilityCode
        facilityType {
          id
          name
        }
        phone
        address
        city
      }
    }
  }
`;
